// Keep legacy saved records aligned with audience-specific public copy.
// Churches retain their faith/model positioning; other audiences focus on tools.
function useCasePublicCopy(data) {
  if (!data || data.slug === 'churches') return data;
  if (data.slug === 'free-thinkers') {
    return {
      ...data,
      tools: data.tools?.map(tool => tool.name === 'Arya AI'
        ? { ...tool, name: 'Model choice', desc: 'Compare models and choose the best fit for your questions' } : tool),
      capabilities: data.capabilities?.map(text => text.includes('Arya')
        ? 'Choose among AI models to explore different answers and approaches' : text),
      faqs: data.faqs?.map(faq => faq.a.includes('Arya')
        ? { ...faq, a: 'You can access 20+ models from major providers — including GPT, Claude, and Gemini — and compare their answers in one place.' } : faq),
    };
  }
  if (data.slug === 'homeschoolers') {
    const cleanKeywords = meta => meta ? { ...meta, keywords: meta.keywords?.replace('Christian homeschool AI, ', '') } : meta;
    return {
      ...data,
      faqs: data.faqs?.map(faq => faq.a.includes('Arya')
        ? { ...faq, a: faq.a.replace(' Arya is available when you want a model grounded in Christian values.', '') } : faq),
      ...(data.seo ? { seo: cleanKeywords(data.seo) } : {}),
      ...(data.meta ? { meta: cleanKeywords(data.meta) } : {}),
    };
  }
  return data;
}
module.exports = { useCasePublicCopy };
